import { useEffect } from 'react';
import { writeProgressDraft } from './progressDraft.ts';
import type { ElementRef } from './useElementRef.ts';

/**
 * Son izleme konumunu cihazda tutar (V6-10).
 *
 * Sunucu raporundan bağımsız çalışır: uygulama çökse veya TV kapansa bile son
 * konum kaybolmaz. `timeupdate` her ~250 ms tetiklenebilir; yazma saniyede en
 * fazla bir kez yapılır, böylece eski TV'lerde depolama yükü oluşmaz.
 */
export function useProgressDraft(
  videoRef: ElementRef<HTMLVideoElement>,
  userId: string | null,
  itemId: string,
  durationMs: number | null,
): void {
  const video = videoRef.element;

  useEffect(() => {
    if (userId === null || video === null) return;
    let lastSaved = 0;
    const save = (): void => {
      const now = Date.now();
      if (now - lastSaved < 1_000) return;
      lastSaved = now;
      writeProgressDraft(userId, itemId, Math.round(video.currentTime * 1_000), durationMs, now);
    };

    video.addEventListener('timeupdate', save);
    video.addEventListener('pause', save);
    return () => {
      save();
      video.removeEventListener('timeupdate', save);
      video.removeEventListener('pause', save);
    };
  }, [userId, itemId, durationMs, video]);
}
